import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TrailerTypeContract } from '~lmo/models/trailerTypeContract.model';
import { TruckingVendorContract } from '~lmo/models/trucking-vendor.model';
import { LmoFracsService, LmoTrailerTypeContractService, LmoTruckingVendorsService } from '~lmo/services';
import { TrailerType } from '~v2Models/well.model';

interface FormValue {
  trailerTypeId: number;
  vendorContractId: number;
}

@Component({
  selector: 'sa-lmo-frac-fctv-trailer-type-contract',
  styleUrls: ['./lmo-frac-fctv-trailer-type-contract.component.scss'],
  templateUrl: './lmo-frac-fctv-trailer-type-contract.component.html',
})
export class LmoFracFctvTrailerTypeContractComponent implements OnInit {
  public newTrailerTypeContractForm: FormGroup;
  public trailerTypes$: Observable<TrailerType[]>;
  public vendorContracts$: Observable<TruckingVendorContract[]>;
  public activeNetworkRequest$ = new BehaviorSubject<boolean>(false);
  public isAllowedToAddMoreTrailerTypeContracts$ = new BehaviorSubject<boolean>(true);

  public get formValue(): FormValue {
    return this.newTrailerTypeContractForm.value;
  }

  constructor(
    private fb: FormBuilder,
    private matDialogRef: MatDialogRef<LmoFracFctvTrailerTypeContractComponent>,
    private fracService: LmoFracsService,
    private truckingVendorService: LmoTruckingVendorsService,
    private trailerTypeContractService: LmoTrailerTypeContractService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  public ngOnInit() {
    this.newTrailerTypeContractForm = this.fb.group({
      trailerTypeId: [null, [Validators.required]],
      vendorContractId: [null, [Validators.required]],
    });
    this.trailerTypes$ = this.fracService.trailerTypes$;
    this.trailerTypes$ = this.trailerTypes$.pipe(
      map((trailerTypes: TrailerType[]) =>
        trailerTypes.filter((trailerType: TrailerType) => !this.data.listOfTrailerTypeId.includes(trailerType.id)),
      ),
    );
    this.trailerTypes$.subscribe((trailerTypes: TrailerType[]) => {
      if (trailerTypes.length === 0) {
        this.isAllowedToAddMoreTrailerTypeContracts$.next(false);
      } else {
        this.isAllowedToAddMoreTrailerTypeContracts$.next(true);
      }
    });
    this.vendorContracts$ = this.truckingVendorService.vendorContracts$;
  }

  public close() {
    this.matDialogRef.close();
  }

  public createTrailerTypeContract() {
    if (this.newTrailerTypeContractForm.invalid) {
      return;
    }
    const formValue = this.formValue;
    const newRequest: TrailerTypeContract = {
      fracClusterTruckingVendorId: this.data.fracClusterTruckingVendorId,
      trailerTypeId: formValue.trailerTypeId,
      vendorContractId: formValue.vendorContractId,
    };
    this.activeNetworkRequest$.next(true);
    this.trailerTypeContractService.createTrailerTypeContract$(newRequest).subscribe(async (success) => {
      this.activeNetworkRequest$.next(false);
      if (success) {
        this.matDialogRef.close(true);
      }
    });
  }

  public trackByTrailerType(index: number, item: TrailerType): number {
    return item.id;
  }

  public trackByVendorContract(index: number, item: TruckingVendorContract): number {
    return item.id;
  }
}
